import React, {Component} from "react";
import {Button, Checkbox, Form, Icon, Input, message,Modal} from "antd";
import CircularProgress from "../../components/CircularProgress/index";
import {
  userChangePassword,
  hideMessage,
  showAuthLoader,
  otpVerified,
  otpResend
} from "../../appRedux/actions/Auth";
import {connect} from "react-redux";
import IntlMessages from "util/IntlMessages";
import {Link} from "react-router-dom";

const FormItem = Form.Item;


class OTP extends Component {

  state = {
    confirmDirty: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log("values", values);
      if (!err) {
        this.props.showAuthLoader();
        this.props.otpVerified(values,this.props.history);
        console.log(e.target.value)

      }
    });

  };
  handleResendOTP = () => {
        this.props.otpResend(localStorage.getItem('emailForSignUp'),this.props.history);
        this.info();
      }
     info= () =>{
    Modal.info({
      title: 'OTP Resent',
      content: (
        <div>
          <p>We have Resent OTP on {localStorage.getItem('emailForSignUp')}</p>
        </div>
      ),
      onOk() {},
    });
  }
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
        this.props.form.resetFields();
      }, 100);
    }
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({confirmDirty: this.state.confirmDirty || !!value});
  }

  render() {

    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;
    return (
      <div className="gx-login-container">
        <div className="gx-login-content">
          <div className="gx-login-header gx-text-center">
            <h1 className="gx-login-title gx-text-primary gx-font-weight-bold">Account Verification</h1>
          </div>
          <center><h4> Please check your email and verify it. Thanks!</h4></center>
          <center><p style={{color:'#54b579'}}>{localStorage.getItem('emailForSignUp')}</p></center>


          <Form onSubmit={this.handleSubmit} className="gx-login-form gx-form-row0">
            <FormItem hidden>
              {getFieldDecorator('email', {
                 initialValue: localStorage.getItem('emailForSignUp'),
                rules: [{
                  required: true, type: 'email', message: 'The input is not valid E-mail!',
                }],
              })(
                <Input name="email" placeholder="Email"/>
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('otp', {
                rules: [{
                  required: true, message: 'The input is not valid OTP!',
                }],
              })(
                <Input name="otp" placeholder="Enter Verification Code"/>
              )}
            </FormItem>
            {/*{loader ?
              <div>
                <CircularProgress className={'gx-loader-view'}/>
              </div> : null}*/}
            {showMessage ?
              message.info(alertMessage.toString()) : null}
            <FormItem className="gx-text-center">
              <Button loading={loader} type="primary" className="gx-mb-0" htmlType="submit">Verify</Button>
              <Link to="/OTP"  onClick={this.handleResendOTP} style={{marginTop:'100px'}}>Resend OTP</Link>

            </FormItem>



          </Form>

        </div>
      </div>
    );
  }
}
const WrappedNormalOTPForm = Form.create()(OTP);

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser} = auth;
  return {loader, alertMessage, showMessage, authUser}
};
export default connect(mapStateToProps, {
  hideMessage,
  showAuthLoader,
  otpVerified,
  otpResend
})(WrappedNormalOTPForm);
